import React from 'react';
import { useData } from "../backend/firebase";
import { getImagePath } from '../utils/imageRegistry';
import SEO from '../components/SEO';

const Standings = () => {
  const { standings, teams } = useData();

  const renderSvgPreview = (svgString) => {
      if(!svgString) return null;
      const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
      return <img src={dataUrl} alt="logo" style={{width: '100%', height: '100%', objectFit: 'contain'}} />;
  };

  // --- UPDATED DISPLAY HELPER (Standings Page) ---
  const getTeamDisplay = (teamId) => {
      const team = teams.find(t => t.id.toString() === teamId?.toString());
      if(!team) return "Unknown Team";

      const size = 40; // Slightly smaller for table
      
      // Shared Style for the Icon
      const iconStyle = {
          width: size,
          height: size,
          borderRadius: '50%',
        //   border: `2px solid ${team.color || '#555'}`, // Team Color Border
          background: team.color || '#1a1a1a', // BACKGROUND IS NOW TEAM COLOR
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          flexShrink: 0
      };

      let iconContent = null;

      // 1. SVG
      if (team.logo) {
          const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(team.logo)}`;
          // No padding, fills the circle
          iconContent = <img src={dataUrl} alt="logo" style={{width: '100%', height: '100%', objectFit: 'cover'}} />;
      } 
      // 2. Standard Image
      else if (team.logoUrl) {
          // No padding, fills the circle
          iconContent = <img src={getImagePath(team.logoUrl)} alt="logo" style={{width: '100%', height: '100%', objectFit: 'cover'}} />;
      }

      return (
          <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
              {/* The Icon Container */}
              <div style={iconStyle}>
                  {iconContent}
              </div>
              
              {/* The Name */}
              <span style={{fontWeight: 'bold', fontSize: 15}}>{team.name}</span>
          </div>
      );
  };

  return (
    <div className="PageLayout">
        <SEO 
            title="Standings & Results" 
            description="View the current standings, match results, and leaderboards for the Bridge Brawl tournament."
            url="/standings" 
        />
        <div className="ContentWrapper">
            <div className="GlassCard">
                {/* MOVED TITLE INSIDE SCROLLAREA */}
                <div className="ScrollArea">
                    <h1 className="SectionTitle">Standings & Results</h1>
                    {standings.map((section, idx) => (
                        <div key={idx} style={{marginBottom: 40}}>
                            <h2 style={{color: '#6C5DD3', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: 10}}>{section.title}</h2>
                            
                            <table style={{width: '100%', borderCollapse: 'collapse', marginTop: 10}}>
                                <thead>
                                    <tr style={{textAlign: 'left', color: '#8F9EB5', fontSize: 12, borderBottom: '1px solid rgba(255,255,255,0.05)'}}>
                                        <th style={{padding: 10}}>Team</th>
                                        {/* Dynamic Columns based on the first row of data */}
                                        {section.rows.length > 0 && Object.keys(section.rows[0].stats).map(key => (
                                            <th key={key} style={{padding: 10, width: 60, textAlign: 'center', textTransform: 'uppercase'}}>{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {section.rows.map((row, rIdx) => (
                                        <tr key={rIdx} style={{borderBottom: '1px solid rgba(255,255,255,0.05)', background: rIdx % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent'}}>
                                            <td style={{padding: 10}}>{getTeamDisplay(row.teamId)}</td>
                                            {Object.keys(row.stats).map(key => (
                                                <td key={key} style={{padding: 10, textAlign: 'center', fontWeight: 'bold'}}>{row.stats[key]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}
                    {standings.length === 0 && <div style={{opacity: 0.5}}>No standings available yet.</div>}
                </div>
            </div>
        </div>
    </div>
  );
};

export default Standings;